import styled from "styled-components";
import { colours } from "../../styles/colours.constants";
import { satoshi500, satoshi900 } from "../../styles/font.constants";
import { spacing } from "../../styles/styles.constants";

export const MODAL_TRANSITION_MS = 200;

export const ModalsWrapper = styled.div<{ $visible: boolean }>`
	position: fixed;
	width: 100vw;
	height: 100vh;
	background-color: ${colours.black}40;
	display: flex;
	justify-content: center;
	align-items: center;
	border: solid 1px ${colours.black}90;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transition: opacity ${MODAL_TRANSITION_MS}ms ease-out;
	// Must beat every other explicit z-index in the app (e.g. formation-grid's
	// player badges at 5, the mentions menu at 10000) so the modal always sits
	// above page content regardless of DOM order.
	z-index: 10001;
`;

export const Modal = styled.div<{ $visible: boolean }>`
	background-color: ${colours.white};
	border-radius: ${spacing.borderRadius};
	padding: 2rem;
	opacity: ${({ $visible }) => ($visible ? 1 : 0)};
	transform: translateY(${({ $visible }) => ($visible ? "-100px" : "-80px")});
	max-width: 31.25rem;
	border: solid 1px ${colours.black}50;
	transition:
		opacity ${MODAL_TRANSITION_MS}ms ease-out,
		transform ${MODAL_TRANSITION_MS}ms ease-out;
`;

export const Title = styled.div`
	${satoshi900};
	text-align: center;
	color: ${colours.black};
	font-size: 1.3rem;
	margin-bottom: 1rem;
`;

export const Text = styled.div`
	${satoshi500};
	text-align: center;
	color: ${colours.black};
	font-size: 1rem;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
	margin-top: 1.5rem;
`;
